export const getNormalizedProjectUserTeams = (teams, projectUserRows) => {
  let projectUserTeams = projectUserRows.map(projectUser => {
    let prTeams = projectUser.project_user_teams;
    let projectUserTeams = [];
    prTeams.forEach(prTeam => {
      let matchedTeam = {};
      teams.forEach(team => {
        if (team.id === prTeam.team_id) {
          matchedTeam = { ...prTeam, id: prTeam.team_id, name: team.name, is_default:team.is_default };
        }
      });
      projectUserTeams.push(matchedTeam);
    });

    return {
      ...projectUser,
      project_user_teams: projectUserTeams
    };
  });
  return projectUserTeams.length > 0 && projectUserTeams;
};
